// src/frontend/data/books/DarkForest/contents.js

export const DARK_FOREST_CONTENTS = [
  { id: 1, title: "Prólogo", type: "external", component: "cap1" },
  { id: 2, title: "Un Flujo completo de creación, respaldo y uso de una billetera cripto", type: "external", component: "cap2" },
  { id: 3, title: "Crear una billetera", type: "external", component: "cap3" },
  { id: 4, title: "Descargas: ¿ cómo no caer en trampas?", type: "external", component: "cap4" },
  { id: 5, title: "Frase Mnemotécnica (Seed Phrase)", type: "external", component: "cap5" },
  { id: 6, title: "Sin claves (Keyless)", type: "external", component: "cap6" },
  { id: 7, title: "Respalda tu billetera", type: "external", component: "cap7" },
  { id: 8, title: "Frase mnemotécnica / Clave privada", type: "external", component: "cap8" },
  { id: 9, title: "Cifrado", type: "external", component: "cap9" },
  { id: 10, title: "¿Cómo usar tu billetera?", type: "external", component: "cap10" },
  { id: 11, title: "AML (Antilavado de dinero)", type: "external", component: "cap11" },
  { id: 12, title: "Billetera fría (Cold Wallet)", type: "external", component: "cap12" },
  { id: 13, title: "Billetera caliente (Hot Wallet)", type: "external", component: "cap13" },
  { id: 14, title: "¿Qué es la seguridad en DeFi?", type: "external", component: "cap14" },
  { id: 15, title: "Seguridad en NFT", type: "external", component: "cap15" },
  { id: 16, title: "¡Cuidado al firmar!", type: "external", component: "cap16" },
  { id: 17, title: "Firmas contraintuitivas", type: "external", component: "cap17" },
  { id: 18, title: "Metodologías Avanzadas de Ataque en Web3", type: "external", component: "cap18" },
  { id: 19, title: "Privacidad tradicional", type: "external", component: "cap19" },
  { id: 20, title: "Sistema operativo", type: "external", component: "cap20" },
  { id: 21, title: "Teléfono móvil", type: "external", component: "cap21" },
  { id: 22, title: "Red", type: "external", component: "cap22" },
  { id: 23, title: "Navegadores", type: "external", component: "cap23" },
  { id: 24, title: "Gestor de contraseñas", type: "external", component: "cap24" },
  { id: 25, title: "Autenticación de dos factores", type: "external", component: "cap25" },
  { id: 26, title: "Navegación avanzada", type: "external", component: "cap26" },
  { id: 27, title: "Correo electrónico", type: "external", component: "cap27" },
  { id: 28, title: "Tarjeta SIM", type: "external", component: "cap28" },
  { id: 29, title: "GPG", type: "external", component: "cap29" },
  { id: 30, title: "Segregación", type: "external", component: "cap30" },
  { id: 31, title: "Seguridad de la naturaleza humana", type: "external", component: "cap31" },
  { id: 32, title: "Telegram", type: "external", component: "cap32" },
  { id: 33, title: "Discord", type: "external", component: "cap33" },
  { id: 34, title: "Phishing ‘oficial’", type: "external", component: "cap34" },
  { id: 35, title: "Privacidad en Web3", type: "external", component: "cap35" },
  { id: 36, title: "Artimañas en blockchain", type: "external", component: "cap36" },
  { id: 37, title: "Qué hacer cuando te hackean", type: "external", component: "cap37" },
  { id: 38, title: "Detén la pérdida primero", type: "external", component: "cap38" },
  { id: 39, title: "Protege la escena", type: "external", component: "cap39" },
  { id: 40, title: "Análisis de causa raíz", type: "external", component: "cap40" },
  { id: 41, title: "Trazado de origen", type: "external", component: "cap41" },
  { id: 42, title: "Conclusión de casos", type: "external", component: "cap42" },
  { id: 43, title: "Conceptos erróneos", type: "external", component: "cap43" },
  { id: 44, title: "El código es ley", type: "external", component: "cap44" },
  { id: 45, title: "No son tus llaves, no son tus monedas", type: "external", component: "cap45" },
  { id: 46, title: "Confiamos en la blockchain", type: "external", component: "cap46" },
  { id: 47, title: "La seguridad criptográfica es seguridad", type: "external", component: "cap47" },
  { id: 48, title: "¿Es humillante ser hackeado?", type: "external", component: "cap48" },
  { id: 49, title: "Actualiza de inmediato", type: "external", component: "cap49" },
  { id: 50, title: "Conclusión", type: "external", component: "cap50" },
  { id: 51, title: "Apéndice", type: "external", component: "cap51" },
  { id: 52, title: "Reglas y principios de seguridad", type: "external", component: "cap52" },
  { id: 53, title: "Colaboradores", type: "external", component: "cap53" },
  { id: 54, title: "Herramientas", type: "external", component: "cap54" },
  { id: 55, title: "Sitios oficiales", type: "external", component: "cap55" },
];
